import { useMemo } from 'react';
/**
 * Domains for which the viewer is considered active
 * @deprecated Use proper widget configuration in CMS instead
 */
export const useLiveStreamActiveWhitelist = () => {
    return useMemo(() => typeof window !== 'undefined' &&
        [
            /business\.fireworktv\.com/,
            /business\.firework\.com/,
            /business\.firework\.tv/,
            /business-staging\.fireworktv\.com/,
            /mandalore-([a-zA-Z0-9-]+)-firework\.vercel\.app/,
        ].some((regexp) => regexp.test(window.location.host)), []);
};
